export default __webpack_public_path__ + "static/webRotator/svg/566857c2fdce329d8a0a51dada64f98f.svg";